/** Fond graphique section Méthode — public/images/Section_5/ */

export const SECTION5_IMAGE_DIR = '/images/Section_5';

export const SECTION5_BACKGROUND_SRC = encodeURI(`${SECTION5_IMAGE_DIR}/Section 5.png`);

/** Fond Section 5 — mode clair. */
export const SECTION5_BACKGROUND_LIGHT_SRC = encodeURI(`${SECTION5_IMAGE_DIR}/Section 5 blanc.png`);
